/**
 * RESPONSIBILITY: the 25th Anniversary band at the top of the Our Story page.
 *
 * One stack, top to bottom: the words, the timeline picture that was printed in the
 * anniversary programme, then the anniversary video. Each part is optional and the band
 * draws only what it has, so it can be filled in over several weeks (R31, R65).
 *
 * Its own section rather than more fields on Our Story: it is its own band with its own
 * pencil, and the day it is retired it is hidden, not unpicked from the story around it.
 *
 * No @EditableBy, so WRITE defaults to NONE — admin only.
 */
import { Section, Text, Paragraph, Img, Link, RenderOf } from '@framework/core/decorators';
import type { ImageValue } from '@framework/core';
import { SectionName } from '../section-names';
import { ABOVE_HINT } from '../hints';

@Section({ name: SectionName.AboutAnniversary, label: 'Our story · 25th Anniversary' })
export class AboutAnniversarySection {
  @Text({ label: 'Subtitle', maxLength: 120, description: ABOVE_HINT })
  eyebrow!: string;

  @Text({ label: 'Title', maxLength: 300 })
  heading!: string;

  @Paragraph({ label: 'Words', maxLength: 20000, rows: 8, markdown: true, allow: ['verse'] })
  body!: string;

  @RenderOf('body')
  bodyHtml!: string;

  /** Shown whole, the width of the column, and opened full size on a click — see Enlarge. */
  @Img({
    label: 'Timeline picture', folder: 'about', maxSizeMb: 24, size: '2400 px wide, any height',
    description: 'The timeline from the programme. Shown whole; a click opens it full size.',
  })
  timeline!: ImageValue;

  @Link({
    label: 'YouTube video', description: 'The link to the video on YouTube, e.g. https://youtu.be/…',
  })
  videoUrl!: string;

  @Text({
    label: 'Video title', maxLength: 300,
    description: 'Read aloud to people using a screen reader, and shown while it loads.',
  })
  videoTitle!: string;
}
